<template>
  <v-container fluid>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :server-items-length="total_rows"
        :footer-props="items_per_page"
        :must-sort="true"
        :loading="loading"
        :mobile-breakpoint="100"
        class="elevation-1"
      >
        <template v-slot:top>
          <hpo-filter :headers="headers" :viewName="viewName" @applyFilter="applyFilter" @quickFilter="quickFilter"></hpo-filter>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td><code>{{ item.DeliveryCode }}</code></td>
            <td>
              <div class="font-weight-medium">{{ item.CustomerCode }}</div>
              <div class="caption grey--text">{{ item.CustomerName }}</div>
            </td>
            <td class="text-right">{{ item.OrderCount }}</td>
            <td class="text-right font-weight-bold blue--text">{{ item.TotalAmount | currency('', 0) }}</td>
            <td>
              <v-chip small :color="item.Status === 1 ? 'green' : 'orange'" dark>
                {{ item.Status === 1 ? 'Đã giao' : 'Chưa giao' }}
              </v-chip>
            </td>
            <td>{{ item.DeliveryDate | display_date }}</td>
            <td>{{ item.CreatedDate | display_date }}</td>
            <td @click.stop>
              <v-btn icon small title="In phiếu giao hàng" @click.stop="openPrintDialog(item)">
                <v-icon medium>mdi-printer</v-icon>
              </v-btn>
              <v-btn icon small title="Xem chi tiết đơn hàng" @click.stop="openDetail(item.ID)">
                <v-icon medium>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Print Dialog -->
    <v-dialog v-model="printDialog" max-width="800px">
      <v-card>
        <v-card-title class="no-print">
          Xem trước phiếu giao hàng
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="doPrint" :loading="printLoading" class="mr-2">
            <v-icon left>mdi-printer</v-icon>In phiếu
          </v-btn>
          <v-btn icon @click="printDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="printItem" id="print-area" class="pa-6">
          <!-- Header -->
          <div class="text-center mb-4">
            <div class="text-h5 font-weight-bold">PHIẾU GIAO HÀNG</div>
            <div class="text-subtitle-1 grey--text">{{ printItem.DeliveryCode }}</div>
          </div>
          <v-divider class="mb-4"></v-divider>

          <!-- Thông tin người nhận -->
          <div class="mb-4">
            <div class="text-subtitle-1 font-weight-bold mb-2">THÔNG TIN NGƯỜI NHẬN</div>
            <table style="width:100%; border-collapse:collapse">
              <tr>
                <td style="width:30%; padding:4px 0"><b>Mã khách hàng:</b></td>
                <td style="padding:4px 0">{{ printItem.CustomerCode }}</td>
                <td style="width:30%; padding:4px 0"><b>Tên khách hàng:</b></td>
                <td style="padding:4px 0">{{ printItem.CustomerName }}</td>
              </tr>
              <tr>
                <td style="padding:4px 0"><b>Trạng thái:</b></td>
                <td style="padding:4px 0">{{ printItem.Status === 1 ? 'Đã giao' : 'Chưa giao' }}</td>
                <td style="padding:4px 0"><b>Ngày giao:</b></td>
                <td style="padding:4px 0">{{ printItem.DeliveryDate | display_date }}</td>
              </tr>
              <tr>
                <td style="padding:4px 0"><b>Ngày tạo:</b></td>
                <td style="padding:4px 0">{{ printItem.CreatedDate | display_date }}</td>
                <td style="padding:4px 0"><b>Tổng phải thu:</b></td>
                <td style="padding:4px 0" class="font-weight-bold red--text">{{ printItem.TotalAmount | currency('', 0) }} đ</td>
              </tr>
            </table>
          </div>
          <v-divider class="mb-4"></v-divider>

          <!-- Danh sách hàng hóa -->
          <div>
            <div class="text-subtitle-1 font-weight-bold mb-2">DANH SÁCH HÀNG HÓA</div>
            <table style="width:100%; border-collapse:collapse; font-size:13px">
              <thead>
                <tr style="background:#f5f5f5">
                  <th style="border:1px solid #ddd; padding:6px; text-align:center">STT</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:left">Mã ĐH</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:left">Mã DHD</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:left">Tên hàng hóa</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:left">Model/Thương hiệu</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:center">SL</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:left">ĐVT</th>
                  <th style="border:1px solid #ddd; padding:6px; text-align:right">Đơn giá (VNĐ)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, idx) in printItem.products" :key="product.ID">
                  <td style="border:1px solid #ddd; padding:6px; text-align:center">{{ idx + 1 }}</td>
                  <td style="border:1px solid #ddd; padding:6px">{{ product.OrderCode }}</td>
                  <td style="border:1px solid #ddd; padding:6px"><code>{{ product.DhdCode }}</code></td>
                  <td style="border:1px solid #ddd; padding:6px">
                    <div>{{ product.ProductNameVN }}</div>
                    <div class="caption grey--text">{{ product.ProductNameEN }}</div>
                  </td>
                  <td style="border:1px solid #ddd; padding:6px">
                    <div v-if="product.Brand">{{ product.Brand }}</div>
                    <div class="caption grey--text" v-if="product.Model">{{ product.Model }}</div>
                  </td>
                  <td style="border:1px solid #ddd; padding:6px; text-align:center">{{ product.Quantity }}</td>
                  <td style="border:1px solid #ddd; padding:6px">{{ product.Unit }}</td>
                  <td style="border:1px solid #ddd; padding:6px; text-align:right">{{ (product.PriceVND || 0) | currency('', 0) }}</td>
                </tr>
                <tr v-if="!printItem.products || printItem.products.length === 0">
                  <td colspan="8" style="border:1px solid #ddd; padding:12px; text-align:center" class="grey--text">Không có hàng hóa</td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="font-weight:bold">
                  <td colspan="5" style="border:1px solid #ddd; padding:6px; text-align:right">Tổng cộng:</td>
                  <td style="border:1px solid #ddd; padding:6px; text-align:center">
                    {{ (printItem.products || []).reduce((s, p) => s + (p.Quantity || 0), 0) }}
                  </td>
                  <td style="border:1px solid #ddd; padding:6px"></td>
                  <td style="border:1px solid #ddd; padding:6px; text-align:right" class="red--text">
                    {{ printItem.TotalAmount | currency('', 0) }} đ
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Footer -->
          <div class="mt-6">
            <table style="width:100%">
              <tr>
                <td style="width:50%; text-align:center">
                  <div class="font-weight-bold mb-1">Người giao hàng</div>
                  <div class="caption grey--text">(Ký, ghi rõ họ tên)</div>
                  <div style="height:60px"></div>
                </td>
                <td style="width:50%; text-align:center">
                  <div class="font-weight-bold mb-1">Người nhận hàng</div>
                  <div class="caption grey--text">(Ký, ghi rõ họ tên)</div>
                  <div style="height:60px"></div>
                </td>
              </tr>
            </table>
          </div>
        </v-card-text>
        <v-card-text v-else-if="printLoading" class="text-center pa-8">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="mt-2 grey--text">Đang tải dữ liệu...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ApiService from '@/services/api.service'
import Filtering from '@/components/Filtering'
import configs from '@/configs'
import _ from 'lodash'
import createPermissionMixin from "@/mixins/permissionMixin";

export default {
  name: 'CnDeliveryList',
  mixins: [createPermissionMixin('cn_delivery')],
  components: {
    'hpo-filter': Filtering
  },
  data() {
    return {
      headers: [
        { text: 'Mã lệnh', value: 'DeliveryCode', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Khách hàng', value: 'CustomerName', filterable: true, quickSearch: true, dataType: configs.DATA_TYPE['String'] },
        { text: 'Số mặt hàng', value: 'OrderCount', filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Tổng phải thu', value: 'TotalAmount', filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Trạng thái', value: 'Status', filterable: true, dataType: configs.DATA_TYPE['Number'] },
        { text: 'Ngày giao', value: 'DeliveryDate', filterable: true, dataType: configs.DATA_TYPE['Date'] },
        { text: 'Ngày tạo', value: 'CreatedDate', filterable: true, dataType: configs.DATA_TYPE['Date'] },
        { text: '', value: 'actions', sortable: false },
      ],
      viewName: 'cn_delivery_list',
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      printDialog: false,
      printLoading: false,
      printItem: null
    }
  },

  computed: {
    ...mapState({
      items: state => state.cnDelivery.all.data,
      total_rows: state => state.cnDelivery.all.total,
      loading: state => state.cnDelivery.loading
    })
  },

  watch: {
    pagination: {
      handler: function () {
        let filterConditions = this.$store.state.commons.filterConditions
        this.filterConditions = filterConditions && filterConditions[this.viewName] ? filterConditions[this.viewName] : []
        this.filter_data()
      },
      deep: true
    }
  },

  mounted() {
    this.$root.$on('REQUEST_CREATE_DATA', this.createNew)
    this.$root.$on('REQUEST_REFRESH_DATA', this.filter_data)
  },

  beforeDestroy() {
    this.$root.$off('REQUEST_CREATE_DATA', this.createNew)
    this.$root.$off('REQUEST_REFRESH_DATA', this.filter_data)
  },

  methods: {
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = _.cloneDeep(configs.PAGINATION)
      this.pagination.sortBy = sortBy
      this.pagination.sortDesc = sortDesc
      this.filterConditions = filterConditions
      this.filter_data()
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions
      this.filter_data()
    },
    filter_data() {
      this.$store.dispatch('cnDelivery/getList', {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      })
    },
    openDetail(id) {
      this.$router.push({ name: 'CnDeliveryDetail', params: { Pid: id } })
    },
    createNew() {
      this.$router.push({ name: 'CnDeliveryDetail', params: { Pid: 0 } })
    },
    async openPrintDialog(item) {
      this.printDialog = true
      this.printItem = null
      this.printLoading = true
      try {
        const response = await ApiService.get(`/api/cn-deliveries/${item.ID}`)
        this.printItem = (response.data && response.data.data) || item
      } catch (e) {
        console.error(e)
        this.printItem = item
      } finally {
        this.printLoading = false
      }
    },
    doPrint() {
      const printArea = document.getElementById('print-area')
      if (!printArea) return
      const win = window.open('', '_blank', 'width=900,height=700')
      win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8">
        <title>Phiếu giao hàng - ${this.printItem.DeliveryCode}</title>
        <style>
          body { font-family: Arial, sans-serif; font-size: 13px; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { padding: 6px 8px; }
          code { font-size: 12px; background: #f0f0f0; padding: 2px 4px; border-radius: 3px; }
          .caption { font-size: 11px; color: #888; }
          @media print {
            body { margin: 10px; }
          }
        </style>
      </head><body>${printArea.innerHTML}</body></html>`)
      win.document.close()
      win.focus()
      setTimeout(() => { win.print(); win.close() }, 400)
    }
  }
}
</script>
